import React from 'react';
import SkeletonWrapper from '@shared/components/skeleton/SkeletonWrapper';
import DemographicsBarChart from './DemographicsBarChart';
import { getPluralSuffix } from '../../../../../utils/plurals';

/**
 * @typedef {object} DemographicsSectionDemographicData
 * @property {*} [ohtPercentages]
 * @property {*} [deviceClassPercentages]
 */

/**
 * @typedef {object} DemographicsSectionProps
 * @property {DemographicsSectionDemographicData} [demographicData]
 * @property {number} [totalUnitCount]
 * @property {boolean} [loading]
 */

/**
 * @param {DemographicsSectionProps} props
 */
const DemographicsSection = props => {
  const { demographicData = {}, totalUnitCount, loading = false } = props;

  return (
    <section className='demographic-section'>
      <SkeletonWrapper show={loading}>
        <h4>{`Demographics of ${totalUnitCount} Site${getPluralSuffix(totalUnitCount)}`}</h4>
      </SkeletonWrapper>

      <div className='charts-wrapper' data-testid='demographic-charts'>
        <DemographicsBarChart data={demographicData.ohtPercentages} loading={loading} />
        <DemographicsBarChart data={demographicData.deviceClassPercentages} loading={loading} />
      </div>
    </section>
  );
};

export default DemographicsSection;
